var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2032 10.3092C38.977 9.4582 38.5314 8.68155 37.9107 8.05694C37.2901 7.43233 36.5163 6.98168 35.6668 6.75009C32.5396 5.90918 20.0396 5.90918 20.0396 5.90918C20.0396 5.90918 7.53955 5.90918 4.41228 6.75009C3.56277 6.98168 2.78898 7.43233 2.16836 8.05694C1.54774 8.68155 1.10206 9.4582 0.875915 10.3092C0.0395509 13.4501 0.0395508 20.0001 0.0395508 20.0001C0.0395508 20.0001 0.0395509 26.5501 0.875915 29.691C1.10206 30.542 1.54774 31.3186 2.16836 31.9432C2.78898 32.5678 3.56277 33.0185 4.41228 33.2501C7.53955 34.091 20.0396 34.091 20.0396 34.091C20.0396 34.091 32.5396 34.091 35.6668 33.2501C36.5163 33.0185 37.2901 32.5678 37.9107 31.9432C38.5314 31.3186 38.977 30.542 39.2032 29.691C40.0396 26.5501 40.0396 20.0001 40.0396 20.0001C40.0396 20.0001 40.0396 13.4501 39.2032 10.3092Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9487 25.9477V14.0522L26.4033 20L15.9487 25.9477Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e2fae358c5728e6830c7b59fbada1179.svg";
export { ForwardRef as ReactComponent };